<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- 共通ヘッダー -->
    <HeaderNav menuflg="0" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
    _/                                                                                                                    _/
    _/      画面定義                                                                                                      _/
    _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STDSDC01C01' }"
                >メインページ</router-link
              >
            </li>
          </ul>
        </div>
        <h1 class="h1">データ収集・配信サービスへようこそ</h1>
        <p class="lead">
          このサービスでは、申告に必要な情報を集めるため、事業者等に書類の提出を依頼することができます。
        <!--  <br />収集した書類は税務申告ソフト「達人シリーズ」に取り込むことができます。 -->
        </p>
        <h2 class="h2">収集作業の流れ</h2>
        <!-- step -->
        <div class="step">
          <div class="step-item">
            <p class="step-title">STEP1</p>
            <p class="step-explain">書類を収集する事業者を登録します。</p>
            <div class="step-image">
              <img
                src="@/assets/images/TDSDC/pict_step01.png"
                width="218"
                height="90"
                alt
              />
            </div>
            <div class="step-btn">
              <a
                href="#"
                class="frm-btn strong large"
                @click.prevent="handleCompanyInfoRegist"
                ref="companyInfoRegistButton"
                >事業者情報の登録</a
              >
            </div>
          </div>
          <div class="step-item">
            <p class="step-title">STEP2</p>
            <p class="step-explain">収集する書類を登録します。</p>
            <div class="step-image">
              <img
                src="@/assets/images/TDSDC/pict_step02.png"
                width="218"
                height="90"
                alt
              />
            </div>
            <div class="step-btn">
              <a
                href="#"
                class="frm-btn strong large"
                @click.prevent="handleDocCollectionRegist"
                >収集情報の登録</a
              >
            </div>
          </div>
          <div class="step-item">
            <p class="step-title">STEP3</p>
            <p class="step-explain">
              事業者に書類の提出を依頼し、
              <br />書類の収集ステータスを確認します。
            </p>
            <div class="step-image">
              <img
                src="@/assets/images/TDSDC/pict_step03.png"
                width="218"
                height="90"
                alt
              />
            </div>
            <div class="step-btn">
              <a
                href="#"
                class="frm-btn strong large"
                @click.prevent="handleDocCollectionManege"
                >書類の収集・管理</a
              >
            </div>
          </div>
        </div>
        <!-- step // -->
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from "@/components/AccountingHeader.vue";
import { API_STDSDC01C01 } from '@/api/Modules/DC01/STDSDC01C01.js'

export default {
  name: "STDSDC01C01",
  components: {
    HeaderNav,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.initFocus();
    API_STDSDC01C01().then((response) => {
      if (response.result == "0000") {
      } else {
        this.$router.push({
          name: "STDSCM04C06",
          state: {
            message: Common.getMessage(response.errorCD, []),
          },
        });
      }
    });
  },
  methods: {
    // **********************************************
    // 事業者情報の登録
    // **********************************************
    handleCompanyInfoRegist() {
      this.$redirect({ name: "STDSDC02C01" });
    },
    // **********************************************
    // 収集書類情報の登録
    // **********************************************
    handleDocCollectionRegist() {
      this.$redirect({ name: "STDSDC03C01" });
    },
    // **********************************************
    // 書類の収集・管理
    // **********************************************
    handleDocCollectionManege() {
      this.$redirect({ name: "STDSDC04C01" });
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.companyInfoRegistButton.focus();
    },
  },
};
</script>

<style scoped>
</style>
